"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.characters = void 0;
// Bucket - sverse-character-storage-(dev | prod)
/**
 * DIRECTORIES
 */
const USABLE_CHARS_DIR = 'usableCharacters';
const ASSEMBLER_DIR = 'assembler';
const DEFAULT_CAST_DIR = 'defaultcast';
const dirs = {
    ASSEMBLER_DIR,
    DEFAULT_CAST_DIR,
    USABLE_CHARS_DIR,
};
/**
 * FILES
 */
// Provide a `key` if the path is constant
// /
const COLORS_FILE = 'colors.json';
const EMPTY_PNG_FILE = 'empty.png';
const INDEX_HTML_FILE = 'index.html';
const VERSION_FILE = 'version.json';
// /usableCharacters/
const CHARACTERS_FILE = 'characters.json';
const EXCLUSIVE_CHARS_FILE = 'exclusiveCharacters.json';
const GLOBAL_CHARS_FILE = 'globalCharacters.json';
const METADATA_FILE = 'metadatas.json';
const files = {
    COLORS_FILE,
    EMPTY_PNG_FILE,
    INDEX_HTML_FILE,
    VERSION_FILE,
    EXCLUSIVE_CHARS_FILE,
    METADATA_FILE,
    CHARACTERS_FILE,
    GLOBAL_CHARS_FILE,
};
/**
 * KEYS - dir + file when path does not take variables
 */
const CHARS_METADATAS_KEY = `${USABLE_CHARS_DIR}/${METADATA_FILE}`;
const EXCLUSIVE_CHARS_KEY = `${USABLE_CHARS_DIR}/${EXCLUSIVE_CHARS_FILE}`;
const GLOBAL_CHARS_KEY = `${USABLE_CHARS_DIR}/${GLOBAL_CHARS_FILE}`;
const CHARS_KEY = `${USABLE_CHARS_DIR}/${CHARACTERS_FILE}`;
const keys = {
    CHARS_METADATAS_KEY,
    EXCLUSIVE_CHARS_KEY,
    GLOBAL_CHARS_KEY,
    CHARS_KEY,
};
exports.characters = {
    files,
    dirs,
    keys,
};
//# sourceMappingURL=index.js.map